/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import {useState, FC} from 'react'
import s from './style.module.css'
import {GameDetailsResponse} from '@app/components/game-player/types/game-player'
import {GameDetail} from '@app/components/game-player/types/game'
import CometLink from '@app/components/custom-links/comet-link'
import analytics from '../events'
import TelemetryBottomSheet from '../telemetry/bottom-sheet-telemetry'
// import HoveringIconWithDraggable from './hovering-icon'
import {PreferencesProvider} from '../../context/preferences'
import {GamesPreferences} from '../../api/get-games-preferences'
import SimilarGamesSlider from '../similar-games'
import RetrySection from './retry'
import {LanguageCodes} from '@app/i18n/settings'
import {getGameWindow} from '@app/components/game-player/helper'
import {usePlayButton} from '@app/components/gameplayer-page/game-image-and-play-btn/play-btn/play-button-context'
import {exitFullScreen} from '@app/components/gameplayer-page/actions-section/buttons/full-screen/full-screen-provider'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'
import dynamic from 'next/dynamic'
const HoveringIconWithDraggable = dynamic(() => import('./hovering-icon'))

declare global {
  interface Window {
    gamezop: any
  }
}

interface Props {
  game: GameDetailsResponse
  similarGames: GameDetail[]
  retryGame: boolean
  lang: LanguageCodes
  propertyCode: string
  theme: string
  isIOS: boolean
  translations: Record<string, string>
  subId: string
  gamePreferences: GamesPreferences
}

const DominoMobile: FC<Props> = ({
  game,
  similarGames,
  retryGame,
  lang,
  propertyCode,
  theme,
  isIOS,
  translations,
  subId,
  gamePreferences,
}) => {
  const [visible, setVisible] = useState<boolean>(false)
  const isDevEnv = process.env.NODE_ENV === 'development'
  const {hideGameScreen} = usePlayButton()
  function pauseGame() {
    if (isDevEnv) {
      console.warn('TESTING: Game paused')
      return // TESTING ONLY
    }
    const gameWind = getGameWindow()
    gameWind?.gamezop?.pause()
  }

  function playGame() {
    if (isDevEnv) {
      console.warn('TESTING: Game played')
      return // TESTING ONLY
    }
    const gameWind = getGameWindow()
    gameWind?.gamezop?.play()
  }

  function hideDominoMenu() {
    setVisible(false)
    playGame()
  }

  return (
    <div>
      <HoveringIconWithDraggable visible={visible} setVisible={setVisible} />

      {visible && (
        <TelemetryBottomSheet pauseGame={pauseGame}>
          <div className={s.overlay} onClick={hideDominoMenu}></div>
          <div className={s.container} data-testid='domino-menu'>
            <PreferencesProvider initialPreferences={gamePreferences}>
              {retryGame && <RetrySection game={game} hideDominoMenu={hideDominoMenu} />}

              <h1 className={s.play_similar_games_heading} data-testid='play-similar-games'>
                {translations['Domino.PlaySimilarGames']}
              </h1>

              <SimilarGamesSlider
                similarGames={similarGames}
                theme={theme}
                isIOS={isIOS}
                lang={lang}
                propertyCode={propertyCode}
                subId={subId}
              />
            </PreferencesProvider>

            <button
              onClick={() => {
                triggerAnalytics('game-exit-button-clicked', {
                  'game-name': game.nameEn,
                  'game-code': game.code,
                }).sendAll()
                hideGameScreen()
                exitFullScreen()
              }}
              className={s.btn_bg}
            >
              <div className={s.btn} data-testid='back-to-home'>
                {translations['Domino.BackToGame']}
              </div>
            </button>
          </div>
        </TelemetryBottomSheet>
      )}
    </div>
  )
}

export default DominoMobile
